/*
 * Copyright (C) 2015 Spanning Cloud Apps. LLC  All rights reserved.
 */
'use strict';

/**
 * Filter module to parse and replace content.
 */
angular
  .module('filters.replace', [])
  /**
   *
   * @param {string} content - The text to replace returns with <br> tags.
   *
   * @returns {string} The <code>content</code> with returns replaced with <br> tag.
   */
  .filter('replaceReturns', function () {
    return function (content) {
      // check if it is a number type or boolean type
      content = _.isNumber(content) || _.isBoolean(content) ? content.toString() : content;
      content = _.isObject(content) ? JSON.stringify(content) : content;
      return content ? content.replace(/(\r\n|\n|\r)/gm, '<br>') : '';
    };
  });
